import React, { useState } from "react";
import logo from "../assets/logo.png";
import { NavLink } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const links = [
    { name: "About", to: "/about" },
    { name: "News", to: "/feed" },
    { name: "Electric Bus", to: "/electricBus" },
    { name: "3-Wheelers", to: "/products" },
    { name: "Research & Development", to: "/research-and-development" },
    { name: "Gallery", to: "/gallery" },
    
    // { name: "Ohmgroup", to: "/ohmgroup" },
    { name: "CSR", to: "/csr" },
    { name: "Contact", to: "/contact" },
  ];

  return (
    <nav className="w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center">
            <NavLink to="/">
              <img className="h-16 w-auto cursor-pointer object-contain" src={logo} alt="Logo" />
            </NavLink>
          </div>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-6">
            {links.map((link, index) => (
              <NavLink
                key={index}
                to={link.to}
                className={({ isActive }) =>
                  `text-bllack px-1 py-2 text-sm font-semibold uppercase tracking-wider ${
                    isActive ? "border-b-2 border-green-500" : "border-b-2 border-transparent"
                  } hover:text-green-400 transition duration-200`
                }
              >
                {link.name}
              </NavLink>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden flex items-center">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-black focus:outline-none"
            >
              <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d={isOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu Dropdown */}
      {isOpen && (
        <div className="lg:hidden bg-black/90 absolute w-full left-0 z-50">
          <div className="px-4 pt-2 pb-4 space-y-2">
            {links.map((link, index) => (
              <NavLink
                key={index}
                to={link.to}
                onClick={() => setIsOpen(false)}
                className={({ isActive }) =>
                  `block text-white px-3 py-2 text-base font-medium uppercase tracking-wider ${
                    isActive ? "text-green-500 font-bold" : ""
                  }`
                }
              >
                {link.name}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;